import React from 'react'
import { useNavigate } from 'react-router-dom'

function ProductCard({el}) {
  const navigate = useNavigate()
  return (
    <div onClick={() => {
      navigate(`/products/${el.slug}`)
    }} className='flex flex-col items-start justify-center cursor-pointer'>
        <img className='w-full h-[20rem] object-cover object-center' src={el.mainImg} alt="" />
        <div className='flex flex-col items-start justify-start gap-0 mt-2'>
            <div className=' text-red-800'>Just In</div>
            <div>{el.name}</div>
            <div className=' text-gray-400'>{el.description}</div>
            <div className=' text-gray-400'>1 Colour</div>
        </div>
        <div className='mt-2'>{el?.price?.toLocaleString('id-ID', {style: 'currency', currency: 'IDR' })}</div>
    </div>
  )
}

export default ProductCard



